module.exports = __webpack_public_path__ + "static/media/default-product-image.a79127c4.png";